module.exports = __webpack_public_path__ + "static/activision-191a5e1967ec5cf7ce839bc349c6d461.jpg";